export default class Estimation {
  smsCredits?: number;

  sms?: number;

  constructor(data: Partial<Estimation>) {
    Object.assign(this, data);
  }
}
